import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { useNavigate } from 'react-router-dom'
import {
	FormValues,
	GroupForm,
} from '@/modules/manage-member/components/GroupForm'
import useMutationCreateGroup from '@/modules/manage-member/api/hooks/useMutateCreateGroup'
import { useRef } from 'react'
import { UseFormReturn } from 'react-hook-form'

export function CreateGroupForm() {
	const { mutate: createGroup } = useMutationCreateGroup()
	const navigate = useNavigate()
	const formRef = useRef<UseFormReturn<FormValues>>(null)

	const handleSubmit = (
		values: FormValues,
		form: UseFormReturn<FormValues>,
	) => {
		try {
			createGroup(values, {
				onSuccess: () => {
					toast.success('สร้างกลุ่มผู้ใช้งานเรียบร้อย')
					navigate(-1)
				},
				onError: (error: any) => {
					const errorMessage = error?.response?.data?.message
					if (errorMessage === 'DUPLICATE_GROUP_NAME') {
						form.setError('name', {
							message: 'ชื่อกลุ่มนี้มีการใช้งานแล้ว',
						})
						return
					}
					showErrorToast('ไม่สามารถสร้างกลุ่มผู้ใช้งานได้')
				},
			})
		} catch (error) {
			showErrorToast(error as Error)
		}
	}

	return (
		<GroupForm
			formRef={formRef}
			onSubmit={handleSubmit}
			submitText="สร้างกลุ่ม"
		/>
	)
}
